import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Stack, CircularProgress } from "@mui/material";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import "./dashboard.css";
import { handleAxiosResponseError } from "utils/handleResponseError";
import axios from "config/axios";
import { useLocation } from "react-router-dom";
import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import SortIcon from "@mui/icons-material/Sort";
import ScrollBar from "components/scrollbar";
import useUserStore from "store/user";
import Todo from "components/Todo/Todo";
import KnowledgeCenter from "components/home/KnowledgeCenter";
import QuickLink from "components/home/QuickLink";
import AgendaDrag from "components/CalenderModal/AgendaDrag";
import EventModel from "components/CalenderModal/EventModel";
import EmailModal from "components/EmailModal/EmailModal";
import AutoSearch from "components/AutoSearch/AutoSearch";
import { getTodos } from "api/all.api";
import { getEvents } from "api/all.api";
import { getNameEvents } from "api/all.api";
import { useQuery } from "@tanstack/react-query";
import { getCalendarUsers } from "api/all.api";
import useLocalStorage from "hooks/useLocalStorage";
import useGmailStore from "store/gmail";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: "0",
  textAlign: "left",
  fontWeight: "bold",
  color: "#000",
}));

const ItemSearch = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  borderRadius: "0",
  textAlign: "center",
  color: "#000",
}));

function Dashboard() {
  const date = new Date();
  const current_time =
    (date.getHours() < 10 ? "0" : "") +
    date.getHours() +
    ":" +
    ((date.getMinutes() < 10 ? "0" : "") + date.getMinutes()) +
    ":" +
    ((date.getSeconds() < 10 ? "0" : "") + date.getSeconds());

  const { setUser, user } = useUserStore();
  const { setToken, clearToken, googleToken, gmailLogged, setLoggedIn } =
    useGmailStore();
  const [longEvents, setLongEvents] = useState([]);
  const [descOpen, setDescOpen] = useState(false);
  const [eventDetail, setEventDetail] = useState({});

  // const [token, setIsToken] = useLocalStorage("token");
  const [outlookToken, setOutlookToken] = useLocalStorage("outlook_email");
  const [outlookEmail, setOutlookEmail] = useLocalStorage("outlook_token");
  const [userMessages, setUserMessages] = useState([]);
  const search = useLocation().search;
  const [isMessageLoad, setIsMessageLoad] = useState(false);
  const [open, setOpen] = useState(false);
  const [sendMessage, setSendMessage] = useState({});
  const [selectAgenda, setSelectAgenda] = useState([]);

  const [isOutlook, setIsOutlook] = useState(false);
  const [outlookLoad, setOutlookLoad] = useState(false);
  const [outlookMessages, setOutlookMessages] = useState([]);
  const [sendSortAgenda, setSendSortAgenda] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [sendAgenda, setSendAgenda] = useState([]);

  const { data: todos, status: todoStatus } = useQuery({
    queryKey: ["todos"],
    queryFn: getTodos,
    staleTime: 1000 * 60 * 60,
  });

  const { data: events, status: eventStatus } = useQuery({
    queryKey: ["events", "logged_out"],
    queryFn: getEvents,
    staleTime: 1000 * 60 * 60,
  });

  const { data: nameEvents, status: nameEventStatus } = useQuery({
    queryKey: ["nameevents"],
    queryFn: getNameEvents,
    staleTime: 1000 * 60 * 60,
  });

  const { data: users, status: userStatus } = useQuery({
    queryKey: ["calendarusers"],
    queryFn: getCalendarUsers,
    staleTime: 1000 * 60 * 60,
  });

  useEffect(() => {
    const code = new URLSearchParams(search).get("code");
    const client_info = new URLSearchParams(search).get("client_info");
    if (!client_info && !userMessages?.length && gmailLogged) {
      axios
        .get(`${process.env.REACT_APP_SERVER_URL}/auth?code=${code}`)
        .then(({ data }) => {
          if (data.access_token) {
            console.log("Token added.");
            setToken(data.access_token);
          }
        })
        .catch((err) => console.log(handleAxiosResponseError(err)));
    }

    if (code && client_info) {
      axios
        .get(
          `${process.env.REACT_APP_SERVER_URL}/get-access-token?code=${code}`
        )
        .then(({ data }) => {
          setOutlookToken(data.accessToken);
          setOutlookEmail(data.account.username);
        })
        .catch((err) => console.log(handleAxiosResponseError(err)));
    }
    // eslint-disable-next-line
  }, [search]);

  useEffect(() => {
    if (googleToken && userMessages.length === 0) {
      setIsMessageLoad(false);
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/getmessages`, {
          googleToken,
        })
        .then(({ data }) => {
          setIsMessageLoad(true);
          setUserMessages(data.email);
        })
        .catch((err) => {
          setIsMessageLoad(false);
          console.log(handleAxiosResponseError(err));
        });
    }
    // eslint-disable-next-line
  }, [googleToken]);

  useEffect(() => {
    if (outlookEmail && outlookToken) {
      setOutlookLoad(false);
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/outlook-messages`, {
          token: outlookToken,
        })
        .then(({ data }) => {
          const { mails } = data;
          setOutlookMessages(mails);
          setOutlookLoad(true);
        })
        .catch((err) => {
          setOutlookLoad(true);

          console.log(handleAxiosResponseError(err));
        });
    }
  }, [outlookEmail, outlookToken]);

  useEffect(() => {
    setLongEvents([]);
    if (events?.length > 0) {
      let longEvents = [];
      events?.forEach((element, index) => {
        if (element.star) {
          let eveUsers = [];
          if (nameEvents && users && users.length) {
            users?.forEach((user) => {
              nameEvents?.forEach((eve) => {
                if (eve.eventId === element._id && eve.eventOff === user._id) {
                  const name = { name: user.firstName + " " + user.lastName };
                  eveUsers.push(name);
                }
              });
            });
          }

          const newEvent = {
            id: element._id,
            title: element.title,
            dueDate: element.allDay
              ? element.date
              : element?.end
              ? element?.end?.split(" ")[0]
              : element?.start?.split(" ")[0],
            date: element.start,
            allDay: element.allDay,
            end: new Date(element.end),
            num: element.num ? element.num : "",
            start: new Date(element.start),
            star: element.star,
            desc: element.description,
            users: eveUsers,
            index,
          };

          const date = new Date().toISOString().split("T")[0];

          if (newEvent.dueDate >= date) longEvents = [...longEvents, newEvent];
        }
      });
      setLongEvents(
        longEvents?.sort((a, b) =>
          a?.dueDate?.toLocaleLowerCase() > b?.dueDate?.toLocaleLowerCase()
            ? 1
            : -1
        )
      );
    }

    return () => {
      setLongEvents([]);
    };
  }, [events, users, nameEvents]);

  const handleSignOut = () => {
    console.log("Clearing Token");
    setIsMessageLoad(false);
    setLoggedIn(false);
    clearToken();
    setUserMessages([]);
  };

  const handleOutlookSignOut = () => {
    setOutlookToken(null);
    setOutlookEmail(null);
    setOutlookMessages([]);
  };

  const handleEmail = (messg) => {
    setSendMessage(messg);
    setOpen(true);
  };

  useEffect(() => {
    setSendAgenda(longEvents);
  }, [longEvents]);

  useEffect(() => {
    setSendAgenda(sendSortAgenda);
  }, [sendSortAgenda]);

  const handleChangeSort = (value) => {
    if (value === 1) {
      const strAscending = sendAgenda.sort((a, b) => {
        return a.title > b.title ? 1 : -1;
      });

      setSendSortAgenda(strAscending);
    } else if (value === 2) {
      const strAscending = sendAgenda.sort((a, b) =>
        a.dueDate > b.dueDate ? 1 : -1
      );

      setSendSortAgenda(strAscending);
    } else if (value === 3) {
      const strAscending = sendAgenda.sort((a, b) =>
        a.dueDate < b.dueDate ? 1 : -1
      );

      setSendSortAgenda(strAscending);
    }

    setShowDropdown(false);
  };

  if (
    userStatus === "loading" ||
    todoStatus === "loading" ||
    eventStatus === "loading" ||
    nameEventStatus === "loading"
  )
    return (
      <div className="d-flex justify-content-center mt-5">
        <CircularProgress color="inherit" />
      </div>
    );

  return (
    <>
      <EventModel
        open={descOpen}
        setOpen={setDescOpen}
        event={eventDetail}
        events={events}
        nameEvents={nameEvents}
        users={users}
      />
      <Grid container spacing={2} className="grid-dashboard">
        <Grid item xl={6} lg={12} md={12} sm={12} xs={12} className="dashboard">
          <Stack spacing={4} className="divs">
            <div style={{ height: "100%" }}>
              {["Calendar - Week View"].map((v) => (
                <Box key={Math.random()} className="calendar-height">
                  <Box
                    sx={{
                      p: 1,
                      bgcolor: "#82b7ea",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 700, fontSize: "16px" }}
                      component="h6"
                      color="white"
                    >
                      {v}
                    </Typography>
                  </Box>

                  <FullCalendar
                    plugins={[timeGridPlugin]}
                    initialView="timeGridWeek"
                    headerToolbar={false}
                    themeSystem="Darkly"
                    events={events}
                    nowIndicator={true}
                    scrollTime={current_time}
                  />
                </Box>
              ))}
            </div>
          </Stack>

          <Stack spacing={4} sx={{ bgcolor: "#97c3e6", marginTop: "10px" }}>
            <div className="grid-todo pt-0 mt-0 mr-0 pr-0">
              <ScrollBar>
                <Todo todos={todos} dashboard={true} />
              </ScrollBar>

              <ScrollBar>
                <Stack>
                  <Item className="d-flex agenda-padding-bottom">
                    <div className="font-weight-bold">Agenda</div>
                    <div style={{ position: "relative" }}>
                      <div
                        color="inherit"
                        className="p-0 sorticon"
                        onClick={() => setShowDropdown(!showDropdown)}
                      >
                        <SortIcon fontSize="small" />
                      </div>
                      {showDropdown && (
                        <div className="droplist2">
                          <Typography
                            className="dropitem"
                            onClick={() => handleChangeSort(1)}
                          >
                            By Alphabetical Order
                          </Typography>
                          <Typography
                            className="dropitem"
                            onClick={() => handleChangeSort(2)}
                          >
                            By Date in Ascending Order
                          </Typography>
                          <Typography
                            className="dropitem"
                            onClick={() => handleChangeSort(3)}
                          >
                            By Date in Descending Order
                          </Typography>
                        </div>
                      )}
                    </div>
                  </Item>
                  <ItemSearch className="auto-search-todo">
                    <AutoSearch
                      items={longEvents}
                      setSearchItem={setSelectAgenda}
                      isAgenda={true}
                    />
                  </ItemSearch>
                  <AgendaDrag
                    agendaList={selectAgenda.length ? selectAgenda : sendAgenda}
                    setEventDetail={setEventDetail}
                    setDescOpen={setDescOpen}
                    dashboard={true}
                  />
                </Stack>
              </ScrollBar>
            </div>
          </Stack>
        </Grid>
        <Grid
          item
          xl={5}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="dashboard knowledge-section-padding"
        >
          <KnowledgeCenter
            user={user}
            setUser={setUser}
            googleToken={googleToken}
            handleSignOut={handleSignOut}
            isMessageLoad={isMessageLoad}
            userMessages={userMessages}
            handleEmail={handleEmail}
            setIsOutlook={setIsOutlook}
            isOutlook={isOutlook}
            outlookMessages={outlookMessages}
            outlookToken={outlookToken}
            outlookLoad={outlookLoad}
            handleOutlookSignOut={handleOutlookSignOut}
          />
        </Grid>
        <Grid
          item
          xl={1}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className="knowledge-section-padding quicklinksmargin"
        >
          <QuickLink user={user} />
        </Grid>
      </Grid>
      <EmailModal open={open} setOpen={setOpen} message={sendMessage} />
    </>
  );
}

export default Dashboard;
